// Dependencies
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

// Components
import TableComponent from '../../TableComponent';
import SectionTitle from '../../SectionTitle';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '../../Alert';

// Queries
import getViaje from '../../Queries/getViaje';

// Styles
import styles from './index.module.sass';

// Images aquí se concentra las 2 imagenes
import logoVI from './images/logoVI-2.png';
// import logoVN from './images/logoVN-2.png';

// Imagenes para el bono Navideño
import BonoEsp from './images/BonoEsp.png';
import BonoIng from './images/BonoIng.png';

const maintenance = false;

const Travel = (props) => {
  const { pathname } = useLocation();
  const { device, webservice, getCookie } = props;
  const { screenSize } = device;
  const [principalTable, setPrincipalTable] = useState([]);
  const [detailTable, setDetailTable] = useState([]);
  const [sponsoringTable, setSponsoringTable] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showImageDiealog, setShowImageDialog] = useState(false);
  const [alertText, setAlertText] = useState('');
  const [openAlert, setOpenAlert] = useState(false);
  const [empty, setempty] = useState(false);
  const { t } = useTranslation('travel');
  const { i18n } = useTranslation();

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const res = await getViaje({
        jsonBody: {
          usuarioOk: getCookie('usuarioOk'),
          viaje: pathname.includes('nationaltravel') ? 'N' : 'I',
        },
      });

      const { typeMessage = 'error', data = {} } = res || {};

      if (typeMessage === 'error' || typeMessage === '409') {
        setAlertText('No se encontro informacion, intentalo nuevamente');
        setPrincipalTable([]);
        setDetailTable([]);
        setSponsoringTable([]);
        setOpenAlert(true);
        setempty(true);
      } else {
        setempty(false);
        const { Detalle = [], Patrocinios = [] } = data;
        setPrincipalTable([res?.data]);
        setDetailTable(Detalle || []);
        setSponsoringTable(Patrocinios || []);
      }

      setLoading(false);
    }
    if (!maintenance) fetchData();
  }, [getCookie, webservice, t, pathname]);

  const principalHeader = t('principalHeader', { returnObjects: true });

  const detailHeader = t('detailHeader', { returnObjects: true });

  const sponsoringHeader = t('sponsoringHeader', { returnObjects: true });

  // console.log(principalTable[0]?.baseDelViaje, 'principalTable');

  return (
    <div id={styles.Travel} className={`${styles.travel} ${styles[screenSize]}`}>
      <Alert open={openAlert} setOpen={setOpenAlert} title='Mensaje del sistema' text={alertText} />
      {showImageDiealog && (
        <div className={styles.imageDialog}>
          <div className={styles.closeIcon} onClick={() => setShowImageDialog(false)}>
            <i className={`material-icons-outlined`}>close</i>
          </div>

          {pathname.includes('nationaltravel') ? (
            <img
              src={`https://webimages.terramarbrands.com.mx/usawebpage/travel/bases/nacional/${
                principalTable[0]?.baseDelViaje
              }${screenSize === 'phone' ? '-mobile' : ''}.webp`}
              alt='travel bases'
              className={styles.travelImage}
            />
          ) : (
            <img
              src={`https://webimages.terramarbrands.com.mx/usawebpage/travel/bases2027/${
                principalTable[0]?.baseDelViaje
              }${screenSize === 'phone' ? '-mobile' : ''}.webp`}
              alt='travel bases'
              className={styles.travelImage}
            />
          )}
        </div>
      )}
      <SectionTitle
        title={pathname.includes('nationaltravel') ? t('title2') : t('title')}
        subtitle={pathname.includes('nationaltravel') ? t('subtitle2') : t('subtitle')}
      />

      <div className={styles.logoContainer}>
        <img
          src={
            pathname.includes('nationaltravel')
              ? i18n.language === 'es'
                ? BonoEsp
                : BonoIng
              : logoVI
          }
          alt='travel logo'
          className={styles.logoImage}
        />
      </div>
      <div className={styles.container}>
        {(maintenance && (
          <div className={styles.maintenance}>
            <div className={styles.maintenanceTitle}>{t('maintenance')}</div>
            <div>{t('soon')}</div>
          </div>
        )) || (
          <>
            <div className={styles.tableHeader}>
              <div className={styles.tableTitle}>{t('principalTitle')}</div>
              <>
                {!empty && (
                  <div
                    onClick={() => setShowImageDialog(true)}
                    className={styles.showBasesTableText}>
                    Ver tabla de bases
                  </div>
                )}
              </>
            </div>
            {(loading && <CircularProgress className={styles.circularProgress} />) || (
              <TableComponent
                screenSize={screenSize}
                tableData={principalTable}
                tableItems={principalHeader}
              />
            )}

            <div className={styles.tableTitle}>{t('detailTitle')}</div>
            {(loading && <CircularProgress className={styles.circularProgress} />) || (
              <TableComponent
                screenSize={screenSize}
                tableData={detailTable}
                tableItems={detailHeader}
              />
            )}

            <div className={styles.tableTitle}>{t('sponsoredTitle')}</div>
            {(loading && <CircularProgress className={styles.circularProgress} />) || (
              <TableComponent
                screenSize={screenSize}
                tableData={sponsoringTable}
                tableItems={sponsoringHeader}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Travel;
